export default __webpack_public_path__ + "static/media/ngo-teaching.c77847d0.jpg";